import React, { Component } from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import Actions from './actions'
import withTranslator from "../../Translator/withTranslation";

const formatter = new Intl.NumberFormat('en', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
});


class AccommodationInfoBlock extends Component {
    constructor(props) {
        super(props);

    }
    openVilla = (url) => {
        var win = window.open(url, '_blank');
        win.focus();
    }
    renderPrice = (villaData, periodSelected) => {
        if (!periodSelected) {
            return formatter.format(villaData.minPrice) + ' ' + this.props.t('map.per_day');
        } else {
            return formatter.format(villaData.priceSum) ;
        }
    }
    renderPricePerNight = (villaData, periodSelected, maxSleeps) => {
        if (!periodSelected) {
            return '';
        } else {
            if (!maxSleeps) {
                maxSleeps = villaData.maxSleeps;
            }
            return formatter.format(villaData.priceSum / periodSelected / maxSleeps ) ;
        }
    }

    render() {
        const { villaData, periodSelected, showBlock, onClose, maxSleeps, t } =  this.props;
        
        return (
            <div className={cx('accommodation-info-block', (showBlock === true) ? 'slideUp' : 'slideDown')}>
               { showBlock &&
                <div className="accommodation-info-block__content height-100 width-100 flex" >
                    <div className="accommodation-info-block__image" onClick={() => {this.openVilla(villaData.villaUri)}}>
                        <img src={villaData && 'https://www.clubvillamar.com' + villaData.picture}/>
                    </div>
                    <div className="accommodation-info-block__elements flex flex-column font-90 p-2">
                        <div className="flex-1">
                            <div className="flex justify-sbetwen">
                                <div className="accommodation-info-block__name flex-1">{villaData && villaData.name}</div>
                                <div className="accommodation-info-block__close font-120 pointer" onClick={onClose}><strong>&times;</strong></div>
                            </div>
                            <div className="accommodation-info-block__location">{villaData.region} - {villaData.city}</div>
                        </div>
                        <div className="flex-1">
                        { !periodSelected && 
                                <div className="starting-at mb-1 font-80"><span>{t('fromprice')}</span></div>
                        }
                        <div><span className="price-info-block">{villaData && this.renderPrice(villaData, periodSelected)}</span></div>
                        {periodSelected && 
                                <div className="price-nights"> <span> { periodSelected }  nights</span>, {this.renderPricePerNight(villaData, periodSelected, maxSleeps)} / {t('map.night')} / {t('map.person')} </div>
                        }
                        </div>
                        <div className="show-villa-btn-container flex-1 flex flex-column justify-fend">
                            <a onClick={() => {this.openVilla(villaData.villaUri.replace(/https?:/gi,''))}} className="btn btn-tertiary btn-sm btn-block show-villa-btn">
                                <span className="">{t('showthisvilla')}</span>
                            </a>
                        </div>
                    </div>
                </div>
                }
            </div>
        )
    }
}

export default connect((state) => {
  return {
    showBlock: state.showBlock,
    villaData: state.villaData,
    villaRef: state.villaRef,
  }
})(withTranslator(AccommodationInfoBlock))